import React from 'react'
import styled from 'styled-components'
import Text from 'core-system/Text'

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0.75rem;
  background-color: ${(props) => props.theme.palette.grey.grey200};
  border-radius: 0.5rem;
`

const Label = styled(Text)`
  color: ${(props) => props.theme.palette.text.placeholder};
  font-size: 0.6875rem;
`

const Value = styled(Text)`
  font-size: 1.375rem;
  font-weight: 700;
  line-height: 1.2;
  color: ${(props) => props.theme.palette.text.primary};
`

const ChangeIndicator = styled.span<{ isPositive: boolean }>`
  font-size: 0.6875rem;
  color: ${(props) =>
    props.isPositive
      ? props.theme.palette.success.green600
      : props.theme.palette.primary.pink600};
  display: flex;
  align-items: center;
  gap: 0.125rem;
`

const Breakdown = styled(Text)`
  color: ${(props) => props.theme.palette.text.placeholder};
  font-size: 0.6875rem;
`

interface StatCardProps {
  label: string
  value: string | number
  change?: string
  changeDirection?: 'up' | 'down'
  breakdown?: string
}

const StatCard: React.FC<StatCardProps> = ({
  label,
  value,
  change,
  changeDirection,
  breakdown,
}) => {
  const isPositive = changeDirection === 'up'

  return (
    <CardContainer>
      <Label variant='caption'>{label}</Label>
      <Value variant='h3'>{value}</Value>
      {change && (
        <ChangeIndicator isPositive={isPositive}>
          {isPositive ? '↑' : '↓'} {change}
        </ChangeIndicator>
      )}
      {breakdown && <Breakdown variant='caption'>{breakdown}</Breakdown>}
    </CardContainer>
  )
}

export default React.memo(StatCard)
